import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import './AdminDashboardPage.css';

const AdminDashboardPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  // Close the mobile sidebar whenever the route changes
  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  // Lock background scroll when the sidebar is open on mobile
  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isSidebarOpen]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="admin-dashboard-layout">
      {/* --- BACKDROP OVERLAY (Mobile) --- */}
      {isSidebarOpen && (
        <div 
          className="admin-sidebar-backdrop" 
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}

      {/* --- SIDEBAR --- */}
      <aside className={`admin-dashboard-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="admin-sidebar-header">
          <h3>Admin Panel</h3>
          {/* Close button visible only on mobile */}
          <button 
            type="button" 
            className="admin-sidebar-close-btn" 
            onClick={closeSidebar}
            aria-label="Close sidebar"
          >
            &times;
          </button>
        </div>

        <nav className="admin-sidebar-nav">
          <NavLink to="/admin/dashboard" end className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-tachometer-alt"></i> Overview
          </NavLink>
          
          <div className="nav-group-label">Pooja & Darshan</div>
          <NavLink to="/admin/bookings" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-gopuram"></i> Manage Bookings
          </NavLink>
          <NavLink to="/admin/pooja-services" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-hands-praying"></i> Pooja Catalogue
          </NavLink>
          <NavLink to="/admin/bhakti-darshan" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-eye"></i> Live Darshan
          </NavLink>

          <div className="nav-group-label">Bhakti Store</div>
          <NavLink to="/admin/orders" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-box"></i> Manage Orders
          </NavLink>
          <NavLink to="/admin/products" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-store"></i> Manage Products
          </NavLink>

          <div className="nav-group-label">Yoga & Courses</div>
          <NavLink to="/admin/catalogues" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-folder-open"></i> Course Catalogues
          </NavLink>
          <NavLink to="/admin/courses" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-book-open"></i> Manage Courses
          </NavLink>
          <NavLink to="/admin/enrollments" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-user-graduate"></i> Student Enrollments
          </NavLink>

          <div className="nav-group-label">Vastu Shastra</div>
          <NavLink to="/admin/vastu-consultations" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-drafting-compass"></i> Vastu Consultations
          </NavLink>
          <NavLink to="/admin/vastu-consultants" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-user-tie"></i> Vastu Consultants
          </NavLink>

          <div className="nav-group-label">Content & Media</div>
          <NavLink to="/admin/daily-spiritual-info" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-bell"></i> Daily Notices
          </NavLink>
          <NavLink to="/admin/bhakti-bal-chitra-katha" className={({ isActive }) => isActive ? 'active-link' : ''}>
            <i className="fas fa-child"></i> Bal Chitra Katha
          </NavLink>
        </nav>
      </aside>

      {/* --- MAIN CONTENT AREA --- */}
      <main className="admin-dashboard-content">
        <button className="sidebar-toggle-btn admin-toggle-btn" onClick={toggleSidebar}>
          <i className="fas fa-bars"></i> Admin Menu
        </button>
        
        <Outlet />
      </main>
    </div>
  );
};

export default AdminDashboardPage;